import React from 'react';
import { FormInputComponent } from "../../../components/form/Form";
import { useOutletContext } from "react-router-dom";
import { usePositionForm } from "../../../providers/PositionFormProvider";
import { useProjectForm } from "../../../providers/ProjectFormProvider";
import {Input} from "antd";

const PositionJobSpecification = props => {

    const { formModel: project } = useProjectForm();
    const { formModel: position, isProjectUpdating } = usePositionForm();
    const {
        isDisabled, goBack, onSubmit, onChange
    } = useOutletContext();


    return (
        <React.Fragment>

            <div className="flex flex-col justify-start items-stretch self-stretch relative gap-4">
                <p className="self-stretch text-lg font-medium text-left text-[#3f434a]">
                    Job Description
                    <span className="text-sm">
                        &nbsp;(Optional)
                    </span>
                </p>
                <FormInputComponent
                    fieldName="description"
                    value={position.description}
                    type="editor"
                    isReadOnly={props.isReadOnly}
                    disabled={isDisabled || isProjectUpdating}
                    maxLength={10000}
                    rows={8}
                    label={!props.isReadOnly && 'Please describe the requirements for this specific position related to the project.'}
                    validationErrors={{
                        isDefaultRequiredValue: TB.trans('validation.required', { attribute: 'description' })
                    }}
                    required={false}
                    placeholder={'Enter description here'} />

                {!props.isReadOnly && (
                    <div className="flex flex-col self-stretch items-stretch max-w-[400px]">
                        <FormInputComponent
                            fieldName="description_file"
                            value={position.description_file}
                            type="file"
                            viewable={typeof position.description_file?.path === 'string'}
                            disabled={isDisabled || isProjectUpdating}
                            label={'Attach position overview document (Optional)'}
                            required={false}
                            fileNameDisplay={() => {
                                return position.description_file &&
                                    typeof position.description_file === 'object'
                                    && position.description_file?.name
                            }}
                        />
                    </div>
                )}
            </div>

            <hr className="my-4" />

            <div className="flex flex-col justify-start items-stretch self-stretch relative gap-4">
                <p className="text-lg font-medium text-left text-[#3f434a]">
                    Minimum Level of Experience
                </p>

                <div>
                    {!props.isReadOnly && (
                        <p className="form-help">
                            Highlight the levels of experience you are most comfortable with (multiple levels can be selected)
                        </p>
                    )}

                    <div className="-mx-2 sm:flex mt-4">
                        <FormInputComponent
                            type="antd-input"
                            fieldName="wants_junior_experience"
                            value={position.wants_junior_experience}
                            disabled={isDisabled || isProjectUpdating}
                            label={false}
                            className="w-full">
                            <Checkbox title="Accomplished" description="< 6 Years"/>
                        </FormInputComponent>

                        <FormInputComponent
                            type="antd-input"
                            fieldName="wants_intermediate_experience"
                            value={position.wants_intermediate_experience}
                            disabled={isDisabled || isProjectUpdating}
                            label={false}
                            className="w-full"
                        >
                            <Checkbox title="Advanced" description="6-10 Years" />
                        </FormInputComponent>

                        <FormInputComponent
                            type="antd-input"
                            fieldName="wants_senior_experience"
                            value={position.wants_senior_experience}
                            disabled={isDisabled || isProjectUpdating}
                            label={false}
                            className="w-full"
                        >
                            <Checkbox title="Expert" description="11+ Years" />
                        </FormInputComponent>

                    </div>

                    <FormInputComponent
                        type="antd-input"
                        fieldName="has_experience"
                        value={position.wants_intermediate_experience
                            || position.wants_senior_experience
                            || position.wants_junior_experience
                        }
                        required={true}
                        validation={
                            {
                                rules: {
                                    hasExperience: function (model, value) {
                                        if (!model.wants_intermediate_experience
                                            && !model.wants_senior_experience
                                            && !model.wants_junior_experience
                                        ) {
                                            return "Please select at least one"
                                        }
                                        return true
                                    },
                                }
                            }
                        }
                        disabled={isDisabled || isProjectUpdating}
                        label={false}
                        className="my-0 p-0">
                        <Input type="hidden"/>
                    </FormInputComponent>
                </div>

            </div>
        </React.Fragment>
    );
};

PositionJobSpecification.propTypes = {

};

export default PositionJobSpecification;

const Checkbox = ({ name, title, description, disabled, onChange, value }) => {
    return (
        <label htmlFor={name} className="w-full">
            <input type="checkbox" checked={value} name={name} id={name} onChange={e => onChange(e.target.checked)} />

            <div
                className={TB.mapClass("experience-tile-select relative flex my-3 sm:my-0 items-center border mx-2 gap-3 px-4 py-3 rounded-lg flex-1 disabled:pointer-events-none", {
                    selected: value,
                    disabled,
                    clickable: !disabled,
                })}
            >
                {value ?
                    <i className="fas fa-check-square text-success" />
                    : <i className="far fa-square" />
                }

                <div className="flex gap-1 flex-col">
                    <h6 className="font-bold mb-0">{title}</h6>
                    <p className="text-sm mb-0">{description}</p>
                </div>
            </div>
        </label>
    )
}